import type { ReaderName } from "@bindery/shared/contracts/session";
import { useSession } from "./use-session";

const NO_READERS: readonly ReaderName[] = [];

/** The readers the signed-in adult may print for; empty until signed in. */
export function useReaderRoster(): readonly ReaderName[] {
  const session = useSession();
  return session.status === "signed-in" ? session.readers : NO_READERS;
}
